// extracted by mini-css-extract-plugin
module.exports =  {"generate-brief-container":"yG_GHl3","generateBriefContainer":"yG_GHl3","ai-image-text":"gGZ35lw","aiImageText":"gGZ35lw","question":"vOIKT02","cta":"qxzNXpB"};